module.exports = __webpack_public_path__ + "img/hat1_6s_5.926a9aae.svg";